import $ from 'jquery';
import config from './../../../config';

export function reset_password( data ){

	return dispatch => {
		$.ajax({
			method: 'GET',
			url: config.apiurl + 'userprofile/',
            data: {
                method : 'RESET_PASSWORD',
                data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "RESET_PASSWORD",
				reset_password: response
			})

		})

    }
    
}

export function sent_verification( email ){

	return dispatch => {
		$.ajax({
			method: 'GET',
			url: config.apiurl + 'userprofile/',
            data: {
                method: 'SEND_VERIFICATION',
                email: email
            }
		})
		.then(function (response) {
			dispatch({
				type: "SEND_VERIFICATION",
				reset_password: response
			})

		})

    }
    
}






// WEBPACK FOOTER //
// ./src/pages/reset/actions/reset.action.js